<template>
  <div>
    <Card>
      <Form :label-width="80" inline @submit.native.prevent>
        <Row style="padding: 20px;">
          <Col span="24">
            <FormItem label="优惠券名称:">
              <label>
                <Input placeholder="请输入优惠券名称" v-model="params.cname" clearable class="search"></Input>
              </label>
            </FormItem>
            <FormItem label="优惠券类型:">
              <label>
                <Select style="width:100px;" v-model="params.ctype">
                  <Option value="0">=全部=</Option>
                  <Option v-for="(d, i) in CoupontempType"
                          :key="i" :value="d.code">{{ d.name }}
                  </Option>
                </Select>
              </label>
            </FormItem>
            <FormItem label="优惠券状态:">
              <label>
                <Select style="width:100px;" v-model="params.status">
                  <Option value="-1">=全部=</Option>
                  <Option v-for="(d, i) in CoupondisStatus" :value="d.code"
                          :key="i">{{ d.name }}
                  </Option>
                </Select>
              </label>
            </FormItem>
            <FormItem label="批次号:">
              <label>
                <Input placeholder="请输入批次号" v-model="params.batchNo" clearable class="search"></Input>
              </label>
            </FormItem>
            </Col>
            <Col span="24">
            <FormItem label="门店名称:">
                <Input placeholder="请输入门店名称" v-model="params.retName" clearable class="search"></Input>
            </FormItem>
            <FormItem label="关联订单号:">
                <Input placeholder="请输入关联订单号" v-model="params.orderId" clearable class="search"></Input>
            </FormItem>
            <FormItem label="有效期:" style="width: 220px;" v-model="params.beginDate">
              <DatePicker type="date" format="yyyy-MM-dd" placeholder="开始日期" @on-change="changeBeginDate"></DatePicker>
            </FormItem>
             </Col>
            <Col span="24">
            <FormItem label="失效日期" style="width: 220px;" v-model="params.endDate">
              <DatePicker type="date" format="yyyy-MM-dd" placeholder="失效日期" @on-change="changeEndDate"></DatePicker>
            </FormItem>
            <!-- <FormItem label="所属平台:">
              <label>
                <Select style="width:100px;" v-model="params.platformCode">
                  <Option value="-1">=全部=</Option>
                  <Option v-for="(item,index) in CouponPlatform"
                          :key="index" :value="item.code">{{ item.name }}
                  </Option>
                </Select>
              </label>
            </FormItem> -->
            <FormItem>
              <Button type="primary" icon="md-search" @click="queryByCondition" v-access="'coupon.use.list.query'">查询</Button>
              <Button type="error" icon="ios-clock" @click="expiredCoupon" v-if="this.CouponChkedList.length>0">置为过期
              </Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Card>
    <Card style="margin-top: 20px;">
      <Row style="padding: 20px;">
        <Table class="table" border stripe height="500" :loading="loading"
               :columns="columnlist"
               :data="CoupondisList"
               @on-select="changeSelectedRow"
               @on-select-all="changeSelectedRow"
               @on-selection-change="changeSelectedRow"
        >
          <template slot-scope="{row, index}" slot="ctypeName">
            <span>{{showCtypeName(row.ctype)}}</span>
          </template>
          <template slot-scope="{row, index}" slot="statusName">
            <span v-if="row.status===1" style="color:green;">未使用</span>
            <span v-if="row.status===2" style="color:grey;">已使用</span>
            <span v-if="row.status===3" style="color:red;">已过期</span>
            <span v-if="row.status===4" style="color:goldenrod;">已失效</span>
          </template>
        </Table>
      </Row>
      <Row type="flex" justify="end">
        <page :total="totalCnt" :page-size="params.pageSize"
              :page-size-opts="[10,20,30,50]"
              @on-change="pageNumChange"
              @on-page-size-change="pageSizeChange"
              show-total show-sizer
              class-name="pagination justify-content-end mg-10"/>
      </Row>
    </Card>
  </div>
</template>

<script>
  const columnlist = [{
    title: '编码',
    key: 'code',
    width: 60,
    type: 'selection'
  }, {
    title: '父级门店ID',
    key: 'parentCode',
    width: 100,
    tooltip: true
  }, {
    title: '优惠券名称',
    key: 'cname',
    tooltip: true,
    width: 200
  }, {
    title: '优惠券类型',
    slot: 'ctypeName',
    width: 150
  }, {
    title: '优惠券状态',
    slot: "statusName",
    width: 120
  }, {
    title: '门店类型',
    key: 'retTypeName',
    width: 150,
    tooltip: true
  }, {
    title: '门店',
    key: 'retName',
    width: 150,
    tooltip: true
  },
  // {
  //   title: '启用金额(元)',
  //   key: 'minAmount',
  //   width: 120
  // },
  {
    title: '批次号',
    key: 'batchNo',
    width: 150
  }, {
    title: '发放时间',
    key: 'createtime',
    width: 120
  }, {
    title: '生效日期',
    key: 'beginDate',
    width: 120
  }, {
    title: '失效日期',
    key: 'endDate',
    width: 120
  }, {
    title: '关联订单号',
    key: 'orderId',
    width: 120,
    tooltip: true
  }, {
    title: '优惠金额',
    key: 'faceAmount',
    width: 120,
    tooltip: true
  }, {
    title: '使用时间',
    key: 'usedDate',
    width: 120,
    tooltip: true
  }, {
    title: '优惠券信息',
    key: "couponInfoDesc",
    width: 220
  },
  // {
  //   title: '所属平台',
  //   key: 'platformName',
  //   width: 150
  // },
  {
    title: '使用说明',
    key: 'couponDesc',
    width: 220,
    tooltip: true
  }, {
    title: '备注',
    key: 'remark',
    width: 220,
    tooltip: true
  }];
  export default {
    name: "list",
    data() {
      return {
        loading: false,
        columnlist,
        CouponChkedList: [],
        CoupontempType: [],
        CoupondisStatus: [],
        CouponPlatform: [],
        params: {
          code: '',
          cname: '',
          batchNo: '',
          platformCode: '-1',
          retCode: '',
          retName: '',
          orderId: '',
          ctype: "0",
          status: "-1",
          beginDate: '',
          endDate: '',
          pageSize: 50,
          pageNum: 1
        },
        CoupondisList: [],
        totalCnt: 0,
        retailerTypeQueryList: [
          { label: "直接订货门店", value: "0" },
          { label: "总仓配货门店", value: "1" },
          { label: "总仓和门店", value: "2" },
          { label: "总仓", value: "3" },
          { label: "联盟总店", value: "21" },
          { label: "联盟分店", value: "22" },
        ],
      };
    },
    methods: {
      showPlatformName(code) {
        for (let i = 0; i < this.CouponPlatform.length; i++) {
          if (code === this.CouponPlatform[i].code) {
            return this.CouponPlatform[i].name;
          }
        }
      },
      showCtypeName(code) {
        for (let i = 0; i < this.CoupontempType.length; i++) {
          if (code.toString() === this.CoupontempType[i].code.toString()) {
            return this.CoupontempType[i].name;
          }
        }
      },
      changeBeginDate(d) {
        this.params.beginDate = d;
      },
      changeEndDate(d) {
        this.params.endDate = d;
      },
      pageNumChange(p) {
        this.params.pageNum = p;
        this.queryCouponDistriblist();
      },
      pageSizeChange(p) {
        this.params.pageSize = p;
        this.queryCouponDistriblist();
      },
      queryByCondition() {
        this.params.pageNum = 1;
        this.queryCouponDistriblist();
      },
      queryCoupontemptype() {
        let http = 'couponTemplateType';
        this.$api[http]({}).then((res) => {
          if (res.code === '200') {
            this.CoupontempType = [];
            for (let d in res.data.CoupontempType) {
              this.CoupontempType.push({code: d, name: res.data.CoupontempType[d]});
            }
          }
        });
      },
      queryCoupontempStatus() {
        //状态，1：未使用；2：已使用；3：已过期；4：已失效；
        this.CoupondisStatus = [
          {code: 1, name: '未使用'}, {code: 2, name: '已使用'}, {code: 3, name: '已过期'}, {code: 4, name: '已失效'}
        ];
      },
      queryBusiPlatform() {
        let http = 'couponqueryBusiPlatform';
        this.$api[http]({}).then((res) => {
          if (res.code === '200') {
            //this.$Message.success('查询优惠券业务平台枚举成功');
            this.CouponPlatform = res.data.CouponPlatform;
          } else {
            this.$Message.error('查询优惠券业务平台枚举失败.');
          }
        });
      },
      queryCouponDistriblist() {
        this.loading = true;
        this.$api['queryCouponDistriblist'](this.params).then((res) => {
          if (res.code === '200') {
            this.$Message.success('查询优惠券列表成功');
            this.CoupondisList = res.data.list;
            this.totalCnt = res.data.total;
            this.CoupondisList.forEach(
              (t) => {
                t.beginDate = t.beginDate ? t.beginDate.substr(0, 10) : '';
                t.createtime = t.createtime ? t.createtime.substr(0, 10) : '';
                t.endDate = t.endDate ? t.endDate.substr(0, 10) : '';
                t.platformName = this.showPlatformName(t.platformCode);
                let con = this.retailerTypeQueryList.filter(s=>(s.value == t.retType));
                if(con.length){
                  t.retTypeName = con[0].label;
                }
                if (t.status === 1) {
                  t._disabled = false;
                } else {
                  t._disabled = true;
                }
              }
            );
          } else {
            this.$Message.error('查询优惠券列表失败.');
          }
          this.loading = false;
        });
      },
      changeSelectedRow(s, r) {
        this.CouponChkedList = s;
      },
      expiredCoupon() {
        this.$Modal.confirm({
          title: '优惠券过期',
          content: '<p>是否要过期这些优惠券？</p>',
          onOk: () => {
            let list = {couponList: []}
            this.CouponChkedList.forEach(
              (d) => {
                list.couponList.push(d.code);
              }
            );
            this.$api['changeCouponDistribStatusExpired'](list).then((res) => {
              if (res.code === '200') {
                this.CoupondisList.forEach(
                  (d) => {
                    list.couponList.forEach(
                      (c) => {
                        if (d.code === c) {
                          d.status = 3;
                          d._disabled = true;
                        }
                      }
                    );
                  }
                );
                this.CouponChkedList = [];
                this.$Message.success('更改优惠券状态为已过期成功');
              } else {
                this.$Message.error('更改优惠券状态为已过期失败.');
              }
            });
          },
          onCancel: () => {
          }
        });
      },
    },
    created() {
      this.queryBusiPlatform();
      this.queryCoupontempStatus();
    },
    watch: {
      CouponPlatform(n, o) {
        this.queryCoupontemptype();
      },
      CoupontempType(n, o) {
        this.queryCouponDistriblist();
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/use/list.vue